module.exports = __webpack_public_path__ + "static/img/pengyouquan.289d47e5.png";